import { useRef, useState, useEffect } from "react";

export function useRecorder() {
  const [status, setStatus] = useState("idle"); // idle | recording | paused | done
  const [elapsed, setElapsed] = useState(0);
  const [blob, setBlob] = useState(null);
  const [analyser, setAnalyser] = useState(null);
  const mr = useRef(null);
  const chunks = useRef([]);
  const stream = useRef(null);
  const timer = useRef(null);
  const audioCtx = useRef(null);

  const tick = () => {
    timer.current = setInterval(() => setElapsed((e) => e + 0.1), 100);
  };
  const cleanup = () => {
    clearInterval(timer.current);
    stream.current?.getTracks().forEach((t) => t.stop());
    audioCtx.current?.close().catch(() => {});
    audioCtx.current = null;
    setAnalyser(null);
  };

  useEffect(() => cleanup, []);

  const start = async () => {
    const s = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.current = s;
    const mime = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/mp4";
    const rec = new MediaRecorder(s, { mimeType: mime });
    chunks.current = [];
    rec.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
    rec.onstop = () => {
      setBlob(new Blob(chunks.current, { type: mime }));
      cleanup();
    };
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const an = ctx.createAnalyser();
    an.fftSize = 256;
    ctx.createMediaStreamSource(s).connect(an);
    audioCtx.current = ctx;
    setAnalyser(an);
    rec.start(250);
    mr.current = rec;
    setElapsed(0);
    setBlob(null);
    setStatus("recording");
    tick();
  };
  const pause = () => {
    mr.current.pause();
    clearInterval(timer.current);
    setStatus("paused");
  };
  const resume = () => {
    mr.current.resume();
    tick();
    setStatus("recording");
  };
  const stop = () => {
    mr.current.stop();
    setStatus("done");
  };
  const reset = () => {
    setBlob(null);
    setElapsed(0);
    setStatus("idle");
  };

  return { status, elapsed, blob, analyser, start, pause, resume, stop, reset };
}
